<template>
  <button class="buttonload" :disabled="loading">
<!--    <i v-if="loading" class="ml-1 fa fa-spinner fa-spin"></i>-->
    <span v-if="loading" class="spinner-grow spinner-grow-sm mr-1" role="status" aria-hidden="true"></span>
    <slot>Submit</slot>
  </button>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  watch: {
    loading(){
    }
  },
  methods: {
    // handleClick() {
    //   this.$emit('onBtnClick');
    // },
  },
};
</script>

<style scoped>

/*.buttonload {*/
/*  padding: 12px 24px; !* Some padding *!*/
/*  font-size: 16px; !* Set a font-size *!*/
/*}*/

.buttonload:disabled {
  pointer-events: stroke;
  cursor: not-allowed;
}

.buttonload i {
  margin-left: -12px;
  margin-right: 8px;
}


</style>
